type ArrayOrObject =
  | Array<unknown>
  | Readonly<{
      [key: string]: unknown;
    }>
  | undefined
  | null;

// Use this to cheaply compare two objects/arrays.
// We ignore a bit of Flow typing issues for simplicity's sake.
export const shallowEqual = (
  ob1: ArrayOrObject,
  ob2: ArrayOrObject,
): boolean => {
  if (ob1 === ob2) {
    return true;
  }

  if (ob1 == null || ob2 == null) {
    return false;
  }

  const keys1 = Object.keys(ob1);
  const keys2 = Object.keys(ob2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let i = 0; i < keys1.length; i++) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown[] | Readonly<{ [key: string]: unknown; }>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown[] | Readonly<{ [key: string]: unknown; }>'.
    if (ob1[keys1[i]] !== ob2[keys2[i]]) {
      return false;
    }
  }

  return true;
};
